<template functional>
  <!-- スロットをダイアログでラップするためのコンポーネント。ダイアログ内のコンポーネントをダイナミックにロードしたいという要求から作成した。（ダイアログごとダイナミックにロードするとダイアログにビルトインのtransitionが使えないため） -->
  <v-dialog
    :value="props.value"
    :max-width="props.maxWidth"
    @input="listeners.input"
  >
    <slot />
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    maxWidth: {
      type: String,
      default: () => '500'
    }
  }
}
</script>
